import React, { useState, useEffect } from 'react'
import { Menu, message } from 'antd'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import MENU from './constants'
import { actionCreators } from '@/store'
import { backToSuperior } from 'request/user'
import './style.scss'
import Cookies from 'js-cookie'
import { TOKEN_KEY } from '../../constants'

function AppMenu(props) {
  const { menuCollapsed, setBreadcrumb, loginUser, personalize } = props
  const [defaultSelected, setDefaultSelected] = useState([])
  const [defaultOpen, setDefaultOpen] = useState([])
  const [openKeys, setOpenKeys] = useState([])
  const [headerEle, setHeaderEle] = useState('')
  const [menuList, setMenuList] = useState([])

  useEffect(() => {
    if (!loginUser.isLevel1Customer) {
      const notAllowMenu = ['customer', 'shop', 'finance']
      const menu = MENU.filter(item => notAllowMenu.indexOf(item.key) === -1)
      setMenuList(menu)
    } else {
      setMenuList(MENU)
    }
  }, [loginUser])

  useEffect(() => {
    if (!personalize || !Object.keys(personalize).length) { // 防止logo和文字的闪烁，等personalize加载完成后生成菜单header
      return
    }
    if (props.location.pathname !== '/login') {
      document.title = personalize.domain ? '设备管理平台' : '芯博士网络设备管理平台'
    }
    const { isLevel1Customer, isSuperLogin } = loginUser
    let header = ''
    if (!isLevel1Customer) {
      if (isSuperLogin) {
        header = <span className="header--back" onClick={backSuperior}>{'<返回上级'}</span>
      } else {
        if (menuCollapsed) {
          header = <span>设备平台</span>
        } else {
          header = personalize.logo ? <img src={personalize.logo}/> : <span>设备平台</span>
        }
      }
    } else {
      header = menuCollapsed ? <span>SIMBOSS</span> : <img src="//simboss.com/www/images/logo.svg"/>
    }

    setHeaderEle(header)
  }, [loginUser, menuCollapsed, personalize])

  useEffect(() => {
    const { pathname } = props.location
    // 根据url获取当前应该展开和选中的菜单
    let probableParentMenu = null
    const getActiveKey = (menuList, path, parentKey) => {
      for (const menu of menuList) {
        if (menu.path === path) {
          return { key: menu.key, label: menu.label, parentKey }
        }
        if (path.indexOf(menu.path) > -1) {
          if (!probableParentMenu || probableParentMenu.path.length < menu.path.length) {
            probableParentMenu = { key: menu.key, label: menu.label, parentKey, path: menu.path }
          }
        }
        if (menu.children) {
          const selected = getActiveKey(menu.children, path, menu.key)
          if (selected) {
            return selected
          }
        }
      }
      return false
    }
    // 获取选中和展开的菜单
    const selectedMenu = getActiveKey(MENU, pathname, 'device') || probableParentMenu
    const cachedActiveMenu = JSON.parse(sessionStorage.getItem('netbox-active-menu') || '{}')
    let key = cachedActiveMenu.key || 'device-list' // 默认选中菜单项(一级或二级菜单)
    let openKey = cachedActiveMenu.openKey || 'device' // 默认展开菜单(一级菜单)
    if (selectedMenu) {
      key = selectedMenu.key
      openKey = selectedMenu.parentKey
      setBreadcrumb(selectedMenu.label)
      sessionStorage.setItem('netbox-active-menu', JSON.stringify({ openKey, key }))
    }
    setDefaultOpen([openKey])
    setDefaultSelected([key])
    if (openKeys.indexOf(openKey) === -1) {
      setOpenKeys([openKey])
    }
  }, [props.location.pathname])

  const backSuperior = async() => {
    const res = await backToSuperior()
    if (!res.success) {
      message.error(res.message)
      return false
    }
    Cookies.set(TOKEN_KEY, res.data, { expires: 1 })
    window.location.href = '/'
  }

  const onMenuClick = menu => {
    const routePath = menu.item.props.path
    props.history.push(routePath)
  }

  const onMenuChange = keys => {
    const lastOpenKey = keys.find(key => openKeys.indexOf(key) === -1)
    if (!MENU.find(menu => menu.key === lastOpenKey)) {
      setOpenKeys(keys)
    } else {
      setOpenKeys(lastOpenKey ? [lastOpenKey] : [])
    }
  }

  return (
    <div className={menuCollapsed ? 'app-menu' : 'app-menu app-menu--collapsed'}>
      {defaultSelected.length > 0 && defaultOpen.length > 0 && (
        <Menu
          defaultSelectedKeys={defaultSelected}
          defaultOpenKeys={defaultOpen}
          selectedKeys={defaultSelected}
          openKeys={openKeys}
          mode="inline"
          theme="dark"
          inlineCollapsed={menuCollapsed}
          onClick={onMenuClick}
          onOpenChange={onMenuChange}
          style={{ height: '100%', background: '#132743' }}
        >
          <header className={menuCollapsed ? 'header-collapsed' : ''}>
            {headerEle}
          </header>
          {menuList.map(menu => {
            return menu.children
              ? (
                <Menu.SubMenu
                  key={menu.key}
                  title={
                    <span>
                      {menu.icon}
                      <span>{menu.label}</span>
                    </span>
                  }
                >
                  {menu.children.map(sub => {
                    return (
                      <Menu.Item key={sub.key} path={sub.path}>
                        {sub.label}
                      </Menu.Item>
                    )
                  })}
                </Menu.SubMenu>
              ) : (
                <Menu.Item key={menu.key} path={menu.path}>
                  {menu.icon}
                  <span>{menu.label}</span>
                </Menu.Item>
              )
          })}
        </Menu>
      )}
    </div>
  )
}

export default connect(state => ({
  menuCollapsed: state.getIn(['common', 'menuCollapsed']),
  loginUser: state.getIn(['common', 'loginUser']),
  personalize: state.getIn(['common', 'personalize'])
}), dispatch => ({
  setBreadcrumb(value) {
    dispatch(actionCreators.setBreadcrumb(value))
  }
}))(withRouter(AppMenu))
